import React from "react";
import RetryAlert from "/components/retry-alert";

export const isAutopayUnavailable = schedulesLoad =>
  !!(schedulesLoad?.isFailure || schedulesLoad?.isLoading);

const AutopayUnavailableAlert = ({ schedulesLoad, onRetry }) =>
  isAutopayUnavailable(schedulesLoad) ? (
    <RetryAlert
      heading="Autopay details are unavailable."
      text="We could not load your autopay settings. Your accounts are still available."
      onRetry={onRetry}
      isRetrying={schedulesLoad.isLoading}
    />
  ) : null;

export default AutopayUnavailableAlert;
